export default "__VITE_ASSET__CinbQD49__"